import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastComponent } from './components/toast/toast.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { CounterDirective } from 'src/app/directives/timer.directive';
import { OtpPipe } from 'src/app/pipes/otp.pipe';
import { NumberOnly } from 'src/app/directives/number-only.directive';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { BlokReqWDComponent } from './components/modal-blocked-request-wd/blocked-req-wd.component';
import { OtpPhoneInputComponent } from './components/otp-phone-input/otp-phone-input.component';
import { ModalTopUpSaldoComponent } from './components/modal-top-up-balance/modal-top-up-balance.component';
import { AntDModule } from './antd.module';
import { ModalMethodPaymentComponent } from './components/modal-method-payment/modal-method-payment.component';
import { ModalQrisPaymentComponent } from './components/modal-qris-payment/modal-qris-payment.component';
import { QRCodeModule } from 'angularx-qrcode';
import { LibsModule } from 'src/app/libs/libs.module';
import { ModalCheckPaymentComponent } from './components/modal-check-payment/modal-check-payment.component';
import { ModalStatusPaymentComponent } from './components/modal-status-payment/modal-status-payment.component';
import { ModalConfirmBackComponent } from './components/modal-confirm-back/modal-confirm-back.component';
import { ModalBannerNotifComponent } from './components/modal-banner-notif/modal-banner-notif.component';
import { MessageNotifComponent } from './components/message-notif/message-notif.component';
import { NotifDrawerComponent } from './components/notif-drawer/notif-drawer.component';
import { ModalVerifEmailTeamComponent } from './components/modal-verif-email-team/modal-verif-email-team.component';
import { ModalVerifOtpComponent } from './components/modal-verif-otp/modal-verif-otp.component';
import { WithdrawlCardComponent } from './components/withdrawl-card/withdrawl-card.component';
import { DateMonthPickerComponent } from './components/date-month-picker/date-month-picker.component';
import { StatCardComponent } from './components/stat-card/stat-card.component';
import { ModalDlRincianSaldo } from './components/modal-download-rincian-saldo/modal-download-rincian-saldo.component';
import { ModalDlDataOrder } from './components/modal-download-data-order/modal-download-data-order.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ModalStartTourComponent } from './components/modal-start-tour/modal-start-tour.component';
import { ModalEndTourComponent } from './components/modal-end-tour/modal-end-tour.component';
import { BannerUpgradeComponent } from './components/banner-upgrade/banner-upgrade.component';

@NgModule({
  declarations: [
    ToastComponent,
    OtpInputComponent,
    OtpPhoneInputComponent,
    OtpPipe,
    CounterDirective,
    NumberOnly,
    MaintenanceComponent,
    BlokReqWDComponent,
    ModalTopUpSaldoComponent,
    ModalMethodPaymentComponent,
    ModalQrisPaymentComponent,
    ModalCheckPaymentComponent,
    ModalStatusPaymentComponent,
    ModalConfirmBackComponent,
    ModalBannerNotifComponent,
    MessageNotifComponent,
    NotifDrawerComponent,
    ModalVerifEmailTeamComponent,
    ModalVerifOtpComponent,
    WithdrawlCardComponent,
    DateMonthPickerComponent,
    StatCardComponent,
    ModalDlRincianSaldo,
    ModalDlDataOrder,
    ModalStartTourComponent,
    ModalEndTourComponent,
    BannerUpgradeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AntDModule,
    QRCodeModule,
    LibsModule,
    RouterModule,
    NgxDaterangepickerMd
  ],
  exports: [
    CommonModule,
    ToastComponent,
    OtpInputComponent,
    OtpPhoneInputComponent,
    CounterDirective,
    OtpPipe,
    NumberOnly,
    ModalTopUpSaldoComponent,
    ModalMethodPaymentComponent,
    ModalQrisPaymentComponent,
    ModalCheckPaymentComponent,
    ModalStatusPaymentComponent,
    ModalConfirmBackComponent,
    ModalBannerNotifComponent,
    MessageNotifComponent,
    NotifDrawerComponent,
    ModalVerifEmailTeamComponent,
    ModalVerifOtpComponent,
    WithdrawlCardComponent,
    DateMonthPickerComponent,
    StatCardComponent,
    ModalDlRincianSaldo,
    ModalDlDataOrder,
    ModalStartTourComponent,
    ModalEndTourComponent,
    BannerUpgradeComponent
  ],
})
export class SharedModule {}
